<template>
  <div>
    <Header :breadcrumsfirst="breadcrumsfirst" :breadcrumslast="breadcrumslast" />
    <Subheader />

    <div class="container">
      <div class="row py-3">
        <label class="form-check-label custom-input mb-3" for="flexSwitchCheckDefault"><strong> Controller
            Configuration</strong></label>
        <div class="col-md-12 mb-4">
          <div class="form-check form-check-inline">
            <label for="assetTypeName" class="custom-label"><strong>Status: </strong>{{ remoteservice.servicestatus
              }}</label>
          </div>
          <div class="form-check form-check-inline">
            <label for="assetTypeName" class="custom-label"><strong>Started On: </strong>{{ remoteservice.starttime
              }}</label>

          </div>
        </div>
        <div class="col-md-12 mb-4">
          <div class="form-check form-check-inline">
            <button class="btn btn-sm btn-primary remote-ops-button" type="button" @click="getServiceStart">Start
              Service</button>
          </div>
          <div class="form-check form-check-inline">
            <button class="btn btn-sm btn-primary remote-ops-button" type="button" @click="getServiceStop">Stop
              Service</button>
          </div>
          <div class="form-check form-check-inline">
            <button class="btn btn-sm btn-primary remote-ops-button" type="button" @click="getServiceReset">Reset
              Service</button>
          </div>
          <div class="form-check form-check-inline">
            <button class="btn btn-sm btn-primary remote-ops-button" type="button" @click="getServiceRestart">Restart
              Controller</button>
          </div>

        </div>
        <div class="col-md-12" :class="{ 'mb-3': !resetPassword, 'mb-2': resetPassword }">

          <div class="form-check form-check-inline">
            <input class="form-check-input shadow-none" type="checkbox" name="inlineRadioOptions" id="inlineRadio2"
              v-model="resetPassword">
            <label class="form-check-label custom-label" for="inlineRadio2">Reset Password</label>
          </div>

        </div>
        <div class="col-md-3" v-if="resetPassword">
          <div class="form-group">
            <label for="assetTypeName" class="custom-label">Username</label>
            <input id="assetTypeName" type="text" class="form-control shadow-none custom-input"
              placeholder="Enter Username" v-model="saveData.username" @input="clearInput">
          </div>
        </div>
        <div class="col-md-3" v-if="resetPassword">
          <div class="form-group">
            <label for="assetTypeName" class="custom-label">New Password</label>
            <input id="assetTypeName" type="password" class="form-control shadow-none custom-input"
              placeholder="Enter Password" v-model="saveData.password" @input="validatePasswords">
            <small v-if="resetPassSuccess === 'failure'" class="text-danger" style="font-size: 11px;">{{
              resetPassMessage }}</small>
            <small v-else-if="resetPassSuccess === 'success'" class="text-success" style="font-size: 11px;">{{
              resetPassMessage }}</small>
          </div>
        </div>
        <div class="col-md-3" :class="{ 'mb-4': !passwordMismatch }" v-if="resetPassword">
          <div class="form-group">
            <label for="assetTypeName" class="custom-label">Confirm Password</label>
            <input id="assetTypeName" type="password" class="form-control shadow-none custom-input"
              placeholder="Enter Password" v-model="confirmPassword" @input="validatePasswords">
            <small v-if="passwordMismatch" class="text-danger" style="font-size: 11px;">Passwords do not match!</small>
          </div>
        </div>
        <div class="col-md-1 d-flex  align-items-center" v-if="resetPassword">
          <div class="form-group ">
            <button class="btn btn-sm btn-outline-secondary filter-button" type="button" :disabled="passwordMismatch"
              @click="changePassword">Submit</button>
          </div>
        </div>
        <label class="form-check-label custom-input mb-2" for="flexSwitchCheckDefault"><strong> System
            Information</strong></label>
        <div v-if="loading" class="loading-indicator-report spinner-border spinner-border"></div>
        <div class="col-md-12 mb-2">
          <table class="table table-bordered table-hover table-responsive">
            <thead class="table-light">
              <tr>
                <th scope="col" class="align-middle">Type</th>
                <th scope="col" class="align-middle">OS Name</th>
                <th scope="col" class="align-middle">Version</th>
                <th scope="col" class="align-middle">Last Installed </th>
                <th scope="col" class="align-middle">Last Updated </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ systeminfo.systemtype }}</td>
                <td>{{ systeminfo.osname }}</td>
                <td>{{ systeminfo.osversion }}</td>
                <td>{{ systeminfo.systemlastinstalled }}</td>
                <td>{{ systeminfo.systemlastupdated }}</td>
              </tr>
            </tbody>
          </table>

        </div>

        <label class="form-check-label custom-input mb-2" for="flexSwitchCheckDefault"><strong> Firmware Details
          </strong></label>

        <div class="col-md-12 mb-2">
          <table class="table table-bordered table-hover table-responsive">
            <thead class="table-light">
              <tr>
                <th scope="col" class="align-middle">Version</th>
                <th scope="col" class="align-middle">Type</th>
                <th scope="col" class="align-middle">Last Updated </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ firmwaredetail.firmwareversion }}</td>
                <td>{{ firmwaredetail.firmwaretype }}</td>
                <td>{{ firmwaredetail.firmwarelastupdated }}</td>
              </tr>
            </tbody>
          </table>

        </div>

        <label class="form-check-label custom-input mb-2" for="flexSwitchCheckDefault"><strong> File System Size
          </strong></label>
        <div class="col-md-12">
          <table class="table table-bordered table-hover table-responsive">
            <thead class="table-light">
              <tr>
                <th scope="col" class="align-middle">Total</th>
                <th scope="col" class="align-middle">Consumed</th>
                <th scope="col" class="align-middle">Available</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ systemsize.totalsize }} GB</td>
                <td>{{ systemsize.usedspace }} GB</td>
                <td>{{ systemsize.availablespace }} GB</td>
              </tr>
            </tbody>
          </table>

        </div>
        <div class="col-md-12 mb-3">
          <div class="form-group">
            <label for="assetTypeNote" class="custom-label">Description</label>
            <textarea id="assetTypeNote" class="form-control shadow-none custom-input" readonly
              rows="4">{{ controllerdata.description }}</textarea>
          </div>
        </div>
        <div class="col-md-12 mb-3">
          <div class="form-group">
            <label for="assetTypeNote" class="custom-label">Notes</label>
            <textarea id="assetTypeNote" class="form-control shadow-none custom-input" readonly
              rows="4">{{ controllerdata.note }}</textarea>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Subheader from '@/components/Subheader.vue'
import { serviceStart, serviceStop, serviceReset, serviceRestart, getResetPassword, getRemoteServiceDetails } from '@/http/remote-ops/controller.http'

export default {
  name: 'asset-type-form',
  components: {
    Header,
    Subheader,
  },
  data() {
    return {
      savePhysicalID: {
        physicalid: this.$route.params.id,
      },
      saveData: {
        physicalid: this.$route.params.id,
      },
      remoteservice: {},
      systeminfo: {},
      firmwaredetail: {},
      systemsize: {},
      controllerdata: {},
      breadcrumsfirst: "Remote Ops",
      breadcrumslast: "Controller",
      resetPassword: false,
      confirmPassword: '',
      passwordMismatch: false,
      resetPassSuccess: "",
      resetPassMessage: "",
      loading: false,
    }
  },
  mounted() {
    this.getDetails();
  },
  methods: {
    async handleServiceAction(action) {
      this.loading = true;
      try {
        const response = await action(this.savePhysicalID);
        const controllerdetail = response.controllerdetail[0];
        this.remoteservice = controllerdetail.remoteservice;
        this.systeminfo = controllerdetail.systeminfo;
        this.firmwaredetail = controllerdetail.firmwaredetail;
        this.systemsize = controllerdetail.systemsize;
        this.controllerdata = controllerdetail.controllerdata;
      } catch (error) {
        this.error = error.message;
      } finally {
        this.loading = false;  // Hide loader
      }
    },
    async getDetails() {
      this.loading = true;
      try {
        const response = await getRemoteServiceDetails(this.savePhysicalID);
        const controllerdetail = response.controllerdetail[0];
        this.remoteservice = controllerdetail.remoteservice;
        this.systeminfo = controllerdetail.systeminfo;
        this.firmwaredetail = controllerdetail.firmwaredetail;
        this.systemsize = controllerdetail.systemsize;
        this.controllerdata = controllerdetail.controllerdata;
      } catch (error) {
        this.error = error.message;
      } finally {
        this.loading = false;  // Hide loader
      }
    },
    getServiceStart() {
      this.handleServiceAction(serviceStart);
    },
    getServiceStop() {
      this.handleServiceAction(serviceStop);
    },
    getServiceReset() {
      this.handleServiceAction(serviceReset);
    },
    getServiceRestart() {
      this.handleServiceAction(serviceRestart);
    },
    changePassword() {
      getResetPassword(this.saveData).then((response) => {
        this.resetPassSuccess = response.success
        this.resetPassMessage = response.message
        if (response.success === "success") {
          this.saveData.username = '';
          this.saveData.password = '';
          this.confirmPassword = '';
          setTimeout(() => {
            this.resetPassMessage = '';
          }, 2000);
        }
      })
    },
    validatePasswords() {
      this.passwordMismatch = this.saveData.password !== this.confirmPassword;
      this.resetPassMessage = '';
    },
    clearInput() {
      this.resetPassMessage = '';
    },
    // checkStatusAndStartService() {

    //   const status = this.$route.query.status;
    //   if (status === 'restart') {
    //     this.getServiceReset();
    //   }
    //   else if (status === 'controller restarted') {
    //     this.getServiceRestart();
    //   }
    //   else if (status === 'inactive') {
    //     this.getServiceStop();
    //   }
    //   else if (status === 'Active') {
    //     this.getServiceStart();
    //   }
    // }
  }
}
</script>


<style scoped></style>